define('plugin/promo/PromoPlugin',['require','lib/plugin/PluginAbstract','plugin/promo/view/PromoView'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var PromoView = require('plugin/promo/view/PromoView');

    return PluginAbstract.extend({

        _detailsStepView: null,
        _promoRegions: {
            promo: '#sb_promo_container'
        },

        initStepManagerEvents: function () {
            this.listenTo(this._stepManager, 'step:render:details', this.beforeDetailsShow);

            if(Config.getInstance().getOption('predefined_promocode')){
                this._stepManager.getBookingModel().set('promo_code', Config.getInstance().getOption('predefined_promocode'));
            }
        },

        /**
         * Before details step shown add promotion region
         *
         * @param DetailsStep step
         * @param DetailsView view
         * @param Marionette.Region region
         */
        beforeDetailsShow: function (step, view, region) {
            this._detailsStepView = view;
            _.each(this._promoRegions, function (selector, region) {
                view.addRegion(region, selector);
            });

            this._detailsStepView.promo.show(new PromoView({
                bookingModel: this._stepManager.getBookingModel()
            }));
        }

    });

});
